import { writable, get } from 'svelte/store';
import { zones } from './zones';
import { dragHandler } from './dragHandler';


export const transfer = writable<{source:DropZone, drag:DragItem, item:any}>({source:undefined, drag:undefined, item:undefined});

export interface DropZone {
    items:DragItem[],
    node:HTMLElement|null,
    dispatcher:any,
}

export interface DragItem {
    item:any;
    node:HTMLElement|null,
}



export function createDropZone( options:{ ghostClasses:string, dispatcher:any } ) {

    let zone:DropZone = { items:[], node:null, dispatcher:options.dispatcher };


    const root = ( n:HTMLElement ) => {
        zone.node = n;
        zones.add( zone );
    };

    const drag = ( n:HTMLElement, init:{item:any, handle?:string } ) => {

        // check if item already exists in zone
        let existing = zone.items.find( i => i.item == init.item );
        if( !existing ) {
            existing = { item:init.item, node:n };
            zone.items.push( existing );
        } else {
            // update node
            existing.node = n;
        }
        
        return dragHandler( existing, options.ghostClasses, zone, init.handle );
    };

    const destroy = () => {
        zones.remove( zone );
    }


    return {
        root,
        drag,
        destroy
    }
}
